module.exports = __webpack_public_path__ + "static/media/First Light ZTG 3568-Edit_720.31b2c2e5.jpeg";